import dynamic from "next/dynamic";

export const DynamicHero004 = dynamic(() => import("./Hero004"), {
  suspense: true,
});
